import { RootState } from '@/store';

export const selectUploadProgress = (state: RootState) =>
  state.ui.app.uploadProgress;

export const selectPushPermissionPostponed = (state: RootState) =>
  state.ui.app.pushPermissionPostponed;

export const selectCommChannelVerificationPostponed = (state: RootState) =>
  state.ui.app.commChannelVerificationPostponed;

export const selectIsNewlyRegisteredUser = (state: RootState) =>
  state.ui.app.newlyRegisteredUser;

export const selectIsUnsignedInvoicesCheckDone = (state: RootState) =>
  !!state.ui.app.unsignedInvoicesCheckDone;
